import React from "react";

interface CharacterAvatarProps {
  avatar?: string | null;
  fallbackClassName?: string;
  imageClassName?: string;
  imageStyle?: React.CSSProperties;
  name: string;
}

export const getCharacterInitial = (name: string) => name.trim().charAt(0).toUpperCase() || "?";

const CharacterAvatar = ({
  avatar,
  fallbackClassName,
  imageClassName,
  imageStyle,
  name,
}: CharacterAvatarProps) => {
  if (avatar) {
    return (
      <img
        src={avatar}
        alt={`${name} avatar`}
        className={imageClassName}
        style={imageStyle}
      />
    );
  }

  return (
    <span className={fallbackClassName} aria-label={`${name} has no avatar`}>
      {getCharacterInitial(name)}
    </span>
  );
};

export default CharacterAvatar;
